import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectFetchFailedAction = {
	type: 'SUBJECT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectFetchFailedAction => ({
	type: 'SUBJECT_FETCH_FAILED',
	payload,
});
